function formatAmount(element, amount) {
  let formattedAmount;

  if (element?.amount === 0) {
    formattedAmount = "0,00";
  } else if (element?.amount !== 0) {
    formattedAmount = Intl.NumberFormat("fr-FR", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.abs(element?.amount));
  } else if (typeof amount === "string") {
    formattedAmount = amount.substring(1);
  } else {
    formattedAmount = amount;
  }

  return `${formattedAmount}`;
}

function formatAmountSum(element, amount) {
  let formattedAmount;
  const linkedSum = Number(element?.linkedGroupSum);

  if (Number.isFinite(linkedSum)) {
    formattedAmount = Intl.NumberFormat("fr-FR", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.abs(linkedSum) === 0 ? 0 : linkedSum);
  } else if (typeof amount === "string") {
    formattedAmount = amount;
  } else if (Number.isFinite(Number(amount))) {
    formattedAmount = Intl.NumberFormat("fr-FR", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount));
  } else {
    formattedAmount = "";
  }

  return `${formattedAmount}`;
}

function splitNumberWithComma(
  number,
  classNames = { int: "int-part", comma: "comma-part", decimal: "decimal-part" }
) {
  if (typeof number !== "number" && typeof number !== "string") return null;

  // Convert to string and use French format for decimal separator
  let numStr =
    typeof number === "number"
      ? number.toLocaleString("fr-FR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : number;

  // Find the comma (French decimal separator)
  const [intPart, decimalPart] = numStr.split(",");

  return (
    `<span class="${classNames.int}">${intPart}</span>` +
    (decimalPart !== undefined
      ? `<span class="${classNames.comma}">,</span><span class="${classNames.decimal}">${decimalPart}</span>`
      : "")
  );
}

function formatFR(amount, showSign = false) {
  amount = Number(amount);

  if (amount === 0) {
    return null;
  }
  if (!isNaN(amount)) {
    const formattedAmount = new Intl.NumberFormat("fr-FR", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.abs(amount));
    return amount > 0 && showSign ? `+${formattedAmount}` : formattedAmount;
  } else {
    return null;
  }
}

function formatFRWithNoDecimals(amount) {
  let amountToString = amount.toString();

  amountToString = amountToString.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return amountToString;
}

function formatNumberToFrench(number) {
  return number
    ? Intl.NumberFormat("fr-FR", {
        style: "decimal",
      }).format(Math.trunc(number))
    : "0";
}
const addEAfterEAccent = (inputString) => {
  if (!inputString) {
    return "";
  }

  return inputString.replace(/é$/, "ée");
};

export {
  formatFR,
  formatAmount,
  formatFRWithNoDecimals,
  formatNumberToFrench,
  addEAfterEAccent,
  formatAmountSum,
  splitNumberWithComma,
};
